import { create } from "zustand";

type SearchFiltersData = {
  year: {
    min: string;
    max: string;
  } | null;
  minCitations: number | undefined;
  authors: string[];
  isOpenAccess: boolean;
  fieldsOfStudy: string[];
  publicationTypes: string[];
  publicationVenues: {
    value: string;
    label?: string;
  }[];
  selectedIFQuartile: number | null;
  mode: "accessible" | "expert";
  selectedFilters: "sota" | "established" | "none";
};

type SearchFiltersActions = {
  setYear: (min: string, max: string) => void;
  setMinCitations: (minCitations: number) => void;
  setAuthors: (authors: string[]) => void;
  setIsOpenAccess: (isOpenAccess: boolean) => void;
  setFieldsOfStudy: (fieldsOfStudy: string[]) => void;
  setPublicationTypes: (publicationTypes: string[]) => void;
  setPublicationVenues: (
    publicationVenues: SearchFiltersData["publicationVenues"]
  ) => void;
  setSelectedIFQuartile: (selectedIFQuartile: number | null) => void;
  setMode: (mode: SearchFiltersData["mode"]) => void;
  setSelectedFilters: (
    selectedFilters: SearchFiltersData["selectedFilters"]
  ) => void;
  handleSelectSota: () => void;
  handleSelectEstablished: () => void;
  handleSelectNone: () => void;
  reset: () => void;
};

const initialState: SearchFiltersData = {
  year: {
    min: "1995",
    max: new Date().getFullYear().toString(),
  },
  minCitations: 20,
  selectedIFQuartile: 3,
  isOpenAccess: false,
  fieldsOfStudy: [],
  publicationTypes: [],
  authors: [],
  publicationVenues: [],
  mode: "expert",
  selectedFilters: "established",
};

const useSearchFilters = create<SearchFiltersData & SearchFiltersActions>(
  (set) => ({
    ...initialState,
    setYear: (min, max) => set({ year: { min, max } }),
    setMinCitations: (minCitations) => set({ minCitations }),
    setAuthors: (authors) => set({ authors }),
    setIsOpenAccess: (isOpenAccess) => set({ isOpenAccess }),
    setFieldsOfStudy: (fieldsOfStudy) => set({ fieldsOfStudy }),
    setPublicationTypes: (publicationTypes) => set({ publicationTypes }),
    setPublicationVenues: (publicationVenues) => set({ publicationVenues }),
    setSelectedIFQuartile: (selectedIFQuartile) => set({ selectedIFQuartile }),
    setMode: (mode) => set({ mode }),
    setSelectedFilters: (selectedFilters) => set({ selectedFilters }),

    handleSelectSota: () => {
      set({
        selectedFilters: "sota",
        year: { min: "2020", max: new Date().getFullYear().toString() },
        minCitations: 0,
        selectedIFQuartile: 2,
        isOpenAccess: false,
        fieldsOfStudy: [],
        publicationTypes: [],
      });
    },

    handleSelectEstablished: () => {
      set({
        ...initialState,
        selectedFilters: "established",
      });
    },

    handleSelectNone: () => {
      set({
        selectedFilters: "none",
        fieldsOfStudy: [],
        minCitations: 0,
        selectedIFQuartile: null,
        publicationTypes: [],
        isOpenAccess: false,
        year: { min: "1900", max: new Date().getFullYear().toString() },
      });
    },

    reset: () => set({ ...initialState, selectedFilters: "none" }),
  })
);

export default useSearchFilters;
